import { connect, MapStateToProps } from 'react-redux';
import { requireProviderTags, updateItem } from 'store/providers/providerSlice';
import ItemManagerModal, {
  IComponentProps,
  IComponentState,
} from '../ItemManagerModal';
import Icon from 'components/Icon';
import {
  Container,
  InfoContainer,
  InfoPart,
  ModalBody,
  SuperContainer,
  InfoContainerWrapper,
  DownloadPart,
  DocumentModalContainer,
  DocumentViewHeader,
} from './styles';
import Button from '../../../Button/Button';
import { bytesToSize } from '../../../../utils/number';
import {
  HintIcon,
  HintText,
  QuestionHintBox,
} from '../Survey/SurveyEditor/GeneralQuestion/styles';
import DocumentVersions from './DocumentVersions';
import NewDocumentVersion from './NewDocumentVersion';
import { HideOnMobile, ShowOnMobile } from '../../../../utils/style/extendable';
import { black } from '../../../../utils/style/colors';
import { setClipboard } from '../../../../containers/Tasks/TasksManagement/TaskUtils';
import notify from '../../../Notify';
import {
  // DocumentViewTypes,
  getViewType,
} from '../../../../store/companies/companiesTypes';
import LocalIcon from '../../../../ui/LocalIcon';
import i18n, { languageDirection } from '../../../../i18n';
import {
  IDocumentView,
  IProviderDocumentViewObj,
  ITagView,
} from '../../../../store/providers/providerTypes';
import { appDispatch, RootState } from '../../../../store/store';
import { ThunkDispatch } from '@reduxjs/toolkit';

interface IProps extends IComponentProps {
  dispatch: ThunkDispatch<any, never, any>;
  showHome?: boolean;
  onClose?: () => void;
}
import MyModal from '../../../Modal';
import { IOpenItem } from '../../../../store/entity/IOpenItem';
import { IThisUserState } from '../../../../store/thisUser/thisUserSlice';
import Helmet from 'react-helmet';
import Collapsible from '../../../Collapsible/Collapsible';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../../CKEditorField/CKEditorField';
import cloneDeep from 'lodash/cloneDeep';
import { display } from '../../../ErrorView/ErrorDialog';
import ZipViewer from '../../../FileViewer/ZipViewer';
import { MaxZipViewerSize } from '../../../FileViewer/FileViewer';
import PdfViewer from '../../../FileViewer/PdfViewer';
import OfficeViewer from '../../../FileViewer/OfficeViewer';
import { getDomainAndPort } from '../../../../api/Utils';
import { smartDateString } from '../../../../utils/date';
import Input from 'components/Input';
import { ChangeEvent } from 'react';
import HeaderThumbnail from '../HeaderThumbnail';

const { domainFeatures } = getDomainAndPort();

const CKEditorConfig = {
  toolbar: {
    items: ['fontColor', 'heading', 'bold'],
  },
  language: i18n.language,
};

export const createBlobFromAnUrl = async (
  url: string,
  type: string,
  setProgress: (percent: number) => void
) => {
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const contentLength = response.headers.get('Content-Length');
      if (!contentLength) {
        throw new Error('Content-Length response header unavailable');
      }
      const total = parseInt(contentLength, 10);
      const reader = response.body?.getReader();
      const chunks: any[] = [];
      let receivedLength = 0;

      const readChunks = async () => {
        // eslint-disable-next-line no-constant-condition
        if (reader) {
          const flag = true;
          while (flag) {
            const { done, value } = await reader.read();
            if (done) break;
            chunks.push(value);
            receivedLength += value.length;
            const progress = (receivedLength / total) * 100;
            setProgress(Number(progress.toFixed(0)));
          }
        }
      };

      return readChunks().then(() => {
        const newBlob = new Blob(chunks, { type: type });
        const objectURL = URL.createObjectURL(newBlob);
        return objectURL;
      });
    })
    .catch((error) => {
      console.error(
        'There has been a problem with your fetch operation:',
        error
      );
    });
};

interface IState extends IComponentState {
  viewingVersion: number | null;
  pdfUrl: string;
  savingDescription: boolean;
  description: string;
  moreInfoLink: string | undefined;
  savingMoreInfoLink: boolean;
}

interface IStateToProps {
  tags: { [p: string | number]: ITagView };
  thisUser: IThisUserState;
}

class DocumentViewModal extends ItemManagerModal<
  IProps & IStateToProps,
  IState
> {
  state = {
    viewingVersion: null,
    pdfUrl: '',
    description: '',
    moreInfoLink: '',
    savingDescription: false,
    savingMoreInfoLink: false,
  };
  UNSAFE_componentWillMount() {
    this.props.dispatch(
      requireProviderTags({
        providerId: this.props.openItem.item.data.providerId,
      })
    );
  }

  componentDidMount() {
    super.componentDidMount();
    const elementById = window.document.getElementById('pdfFrame') as any;
    try {
      if (elementById) {
        elementById.contentWindow.onload = function () {
          this.document.getElementsByTagName('img')[0].style.width = '100%';
        };
        if (elementById.contentWindow.document) {
          if (elementById.contentWindow.document.getElementById('img')) {
            elementById.contentWindow.document.getElementById(
              'img'
            )[0].style.width = '100%';
          }
        }
      }
    } catch (e) {
      /*do nothing */
    }

    if (this.props.openItem.item.data.description) {
      this.setState({
        description: this.props.openItem.item.data.description,
      });
    }

    if (this.props.openItem.item.data?.moreInfoUrl) {
      this.setState({
        moreInfoLink: this.props.openItem.item.data.moreInfoUrl,
      });
    }
  }

  getModalStyle() {
    return {
      width: '100%',
      top: '0% !important',
      height: '100%',
      maxHeight: 'calc(100% - 40px)',
      display: 'flex',
      flexFlow: 'column',
      overflow: 'hidden',
      boxShadow: 'none',
    };
  }

  changeVersion = (id: number) => {
    this.setState({ viewingVersion: id });
  };

  handleSubmitDescription = () => {
    const item = cloneDeep(this.props.openItem.item.data);
    item.description = this.state.description;
    this.setState({ savingDescription: true });
    appDispatch(updateItem({ item }) as any).then(
      () => {
        this.setState({ savingDescription: false });
      },
      (err: any) => {
        display(err);
      }
    );
  };

  render() {
    const { openItem } = this.props;
    if (this.props.thisUser?.isLoggedIn) return super.render();
    return (
      <MyModal
        onClose={() => this.props?.onClose && this.props?.onClose()}
        title={openItem.item.data.name as string}
        isActive={true}
        onSelectATab={() => {
          /*do nothing*/
        }}
        height={'auto'}
        showHome={this.props.showHome}
        sideElements={
          <Button
            onClick={() => {
              try {
                navigator.share({
                  title: openItem.item.data.name + ' #نه_به_تصادف',
                  url: window.location.href,
                });
              } catch (error) {
                /*do nothing*/
              }
            }}
          >
            {i18n.t('share', { ns: 'modals' }) as string}
          </Button>
        }
      >
        {this.getContent(openItem)}
      </MyModal>
    );
  }

  getContent = (openItem: IOpenItem) => {
    const { viewingVersion: newViewingVerison } = this.state;
    const viewingVersion =
      newViewingVerison ||
      (openItem.item.data as IProviderDocumentViewObj).currentDocumentId;

    const viewingDocument = viewingVersion
      ? ((openItem.item.data as IProviderDocumentViewObj).versions.find(
          (it) => it.document.id === viewingVersion
        )?.document as IDocumentView)
      : ((openItem.item.data as IProviderDocumentViewObj)
          ?.document as IDocumentView);
    // const versionInfo = viewingVersion
    //   ? (openItem.item.data as IProviderDocumentViewObj)?.versions.find(
    //       (it) => it.document.id === viewingVersion
    //     )
    //   : undefined;
    const viewType =
      viewingDocument && getViewType(viewingDocument.properties.format);
    let format;
    try {
      const parts = new URL(viewingDocument!.url).pathname.split(/[. ]+/);
      if (parts.length > 1) format = parts.pop();
      else format = viewingDocument?.properties.format;
    } catch (e) {
      format = viewingDocument?.properties?.format;
    }
    let type = viewingDocument?.properties?.format;
    if (!type?.includes('/')) {
      type = 'video/mp4';
    }
    return (
      <Container
        style={{
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Helmet>
          <title>{openItem.item.data.name}</title>
        </Helmet>
        {viewType === 'video' && (
          <video style={{ width: '100%' }} controls autoPlay>
            <source src={viewingDocument?.url} />
            Your browser does not support this file
          </video>
        )}
        {viewType === 'audio' && (
          <audio style={{ width: '80%', margin: ' 100px 0 100px 0' }} controls>
            <source src={viewingDocument?.url} />
            Your browser does not support this file
          </audio>
        )}
        {viewType === 'pdf' && (
          <>
            <HideOnMobile style={{ width: '100%', height: '100%' }}>
              <PdfViewer
                pdfURL={viewingDocument?.url as string}
                name={openItem.item.data.name || ''}
              />
            </HideOnMobile>
            <ShowOnMobile>
              <Button
                style={{ margin: '2rem' }}
                color="green"
                onClick={() => window.open(viewingDocument?.url, '_black')}
              >
                {i18n.t('view', { ns: 'modals' }) as string}
              </Button>
            </ShowOnMobile>
          </>
        )}
        {viewType === 'image' && (
          <div style={{ overflow: 'auto' }}>
            <img
              alt={viewingDocument?.properties.displayName}
              title={openItem.item.data.name as string}
              style={{
                height: 'auto',
                width: '100%',
                objectFit: 'scale-down',
              }}
              src={viewingDocument?.url}
            />
          </div>
        )}
        {viewType === 'zip' && (
          <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            {viewingDocument.fileSize < MaxZipViewerSize ? (
              <ZipViewer fileUrl={viewingDocument?.url as string} />
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  justifyContent: 'center',
                }}
              >
                <QuestionHintBox>
                  <HintIcon type="info" />
                  <HintText>
                    <span>
                      {i18n.t('exccesedSize', { ns: 'survey' }) as string}
                    </span>
                  </HintText>
                </QuestionHintBox>
                <Button
                  color="black-outline"
                  onClick={() => window.open(viewingDocument.url, '_black')}
                >
                  {i18n.t('download', { ns: 'modals' }) as string}
                </Button>
              </div>
            )}
          </div>
        )}
        {viewType === 'office' && (
          <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <OfficeViewer
              fileUrl={viewingDocument?.url as string}
              fileType={format}
            />
          </div>
        )}
        {viewType === 'unknown' && (
          <QuestionHintBox>
            <HintIcon type="info" />
            <HintText>
              <span>
                {i18n.t('unknownFormat', { ns: 'modals', format }) as string}
              </span>
            </HintText>
          </QuestionHintBox>
        )}
      </Container>
    );
  };

  handleChangeDescription = (description: string) => {
    this.setState({ description: description });
  };

  handleChangemoreInfoLink = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ moreInfoLink: event.target.value });
  };

  handleSaveMoreInfoLink = () => {
    const item = cloneDeep(this.props.openItem.item.data);
    item.moreInfoUrl = this.state.moreInfoLink;
    this.setState({ savingMoreInfoLink: true });
    appDispatch(updateItem({ item }) as any).then(
      () => {
        this.setState({ savingMoreInfoLink: false });
      },
      (err: any) => {
        display(err);
      }
    );
  };

  renderChild() {
    const { openItem, onClose, onMinimize, showHome } = this.props;
    const { viewingVersion: newViewingVersion } = this.state;
    const viewingVersion =
      newViewingVersion ||
      (openItem.item.data as IProviderDocumentViewObj).currentDocumentId;

    const allowDownload = openItem.item.data.editable
      ? true
      : !domainFeatures?.preventDownload;

    const viewingDocument = viewingVersion
      ? (openItem.item.data as IProviderDocumentViewObj).versions.find(
          (it) => it.document.id === viewingVersion
        )?.document
      : openItem.item.data.document;
    const versionInfo = viewingVersion
      ? (openItem.item.data as IProviderDocumentViewObj).versions.find(
          (it) => it.document.id === viewingVersion
        )
      : undefined;
    // const viewType: DocumentViewTypes =
    //   viewingDocument && getViewType(viewingDocument.properties.format);
    // let format: string;
    // try {
    //   const parts = new URL(viewingDocument.url).pathname.split(/[. ]+/);
    //   if (parts.length > 1) format = parts.pop() as string;
    //   else format = viewingDocument.properties.format;
    // } catch (e) {
    //   format = viewingDocument?.properties?.format;
    // }
    // let type = viewingDocument?.properties?.format;
    // if (!type?.includes('/')) {
    //   type = 'video/mp4';
    // }
    return (
      <>
        <DocumentModalContainer>
          <header
            style={{
              boxShadow: 'none',
              padding: '0.5rem',
              background: 'var(--exact-white)',
            }}
          >
            <div
              className="nav-wrapper"
              style={{
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <ul
                id="navigation-buttons"
                className="right"
                style={{ display: 'flex' }}
              >
                {onClose && (
                  <LocalIcon
                    iconName="close-square.svg"
                    color="no-color"
                    type="sm"
                    onClick={(e) => {
                      e.preventDefault();
                      onClose();
                    }}
                    isLink={true}
                    style={{
                      marginInlineEnd: '0',
                      margin: 'auto',
                      width: '2.5rem',
                    }}
                  />
                )}
                {showHome && (
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = '/home';
                    }}
                  >
                    <Icon type="home" />
                  </a>
                )}
                {onMinimize && (
                  <LocalIcon
                    iconName="minimize.svg"
                    color="no-color"
                    type="sm"
                    onClick={(e) => {
                      e.preventDefault();
                      onMinimize();
                    }}
                    isLink={true}
                  />
                )}
              </ul>
              <HeaderThumbnail item={openItem.item.data} />
              <DocumentViewHeader>{openItem.item.data.name}</DocumentViewHeader>
            </div>
          </header>
          <ModalBody className="row" style={{ marginTop: '10px' }}>
            {!viewingDocument && (
              <div>
                {
                  i18n.t('documentContentPermanentlyRemoved', {
                    ns: 'modals',
                  }) as string
                }
              </div>
            )}
            {viewingDocument && (
              <>
                <InfoContainerWrapper className="col s12 m3">
                  <InfoContainer style={{ height: '100%' }}>
                    <>
                      <InfoPart>
                        <b>
                          {i18n.t('uploadDate', { ns: 'modals' }) as string}:
                          {''}
                        </b>
                        <span>
                          {smartDateString(
                            openItem.item.data.creationDate,
                            false,
                            true
                          )}
                        </span>
                      </InfoPart>
                      <InfoPart>
                        <b>
                          {i18n.t('fileSize', { ns: 'modals' }) as string}:{' '}
                        </b>
                        <span>{bytesToSize(viewingDocument.fileSize)}</span>
                      </InfoPart>
                      {versionInfo && (
                        <>
                          <InfoPart>
                            <b>
                              {
                                i18n.t('versionName', {
                                  ns: 'modals',
                                }) as string
                              }
                            </b>
                            <span>{versionInfo.properties.name}</span>
                          </InfoPart>
                          <InfoPart>
                            <b>
                              {
                                i18n.t('versionDate', {
                                  ns: 'modals',
                                }) as string
                              }
                              :{' '}
                            </b>
                            <span>
                              {smartDateString(
                                versionInfo.creationDate,
                                true,
                                true
                              )}
                            </span>
                          </InfoPart>
                        </>
                      )}
                      {allowDownload && (
                        <DownloadPart>
                          <Button
                            color="black-outline"
                            onClick={() =>
                              window.open(viewingDocument.url, '_black')
                            }
                          >
                            {i18n.t('download', { ns: 'modals' }) as string}
                          </Button>
                          <LocalIcon
                            iconName="link.svg"
                            color={black}
                            onClick={() => {
                              setClipboard(viewingDocument.url);
                              notify(i18n.t('copied', { ns: 'modals' }));
                            }}
                            isLink={true}
                          />
                        </DownloadPart>
                      )}
                    </>
                  </InfoContainer>
                  {(openItem.item.data as IProviderDocumentViewObj)
                    .currentDocumentId && (
                    <div
                      style={{
                        overflowY: 'auto',
                        maxHeight: 'calc(100vh - 290px) ',
                      }}
                    >
                      {openItem.item.data.editable && (
                        <>
                          {!openItem.item.data.upstreamItemId && (
                            <NewDocumentVersion item={openItem.item.data} />
                          )}

                          <DocumentVersions
                            itemWithData={openItem.item}
                            item={openItem.item.data}
                            viewingVersion={
                              this.state.viewingVersion ||
                              (openItem.item.data as IProviderDocumentViewObj)
                                .currentDocumentId
                            }
                            changeViewingVersion={this.changeVersion}
                          />

                          <Collapsible
                            header={
                              <div>
                                <span>
                                  {
                                    i18n.t('description', {
                                      ns: 'modals',
                                    }) as string
                                  }
                                </span>
                              </div>
                            }
                          >
                            <div className="flex flex-col gap-3">
                              <CKEditorField
                                label={
                                  i18n.t('nameTitle', {
                                    ns: 'documentManager',
                                  }) as string
                                }
                                onChange={(_: any, editor: any) => {
                                  const data = editor.getData();
                                  this.handleChangeDescription(data);
                                }}
                                data={this.state.description}
                                dir={`${languageDirection()}`}
                                disabled={
                                  !openItem.item.data.editable ||
                                  openItem.item.data.upstreamItemId
                                }
                                config={
                                  openItem.item.data.editable &&
                                  !openItem.item.data.upstreamItemId
                                    ? CKEditorConfig
                                    : CKEditorReadOnlyConfig
                                }
                              />
                              {openItem.item.data.editable &&
                                !openItem.item.data.upstreamItemId && (
                                  <div>
                                    <Button
                                      type="button"
                                      color={'black-outline'}
                                      onClick={this.handleSubmitDescription}
                                      loading={this.state.savingDescription}
                                    >
                                      {
                                        i18n.t('confirm', {
                                          ns: 'taskManager',
                                        }) as string
                                      }
                                    </Button>
                                  </div>
                                )}
                            </div>
                          </Collapsible>

                          <Collapsible
                            header={
                              <div>
                                <span>
                                  {
                                    i18n.t('moreInfoLink', {
                                      ns: 'modals',
                                    }) as string
                                  }
                                </span>
                              </div>
                            }
                          >
                            <div className="flex flex-col gap-3">
                              <Input
                                id="moreInfoLink"
                                type="text"
                                label={
                                  i18n.t('moreInfoLink', {
                                    ns: 'modals',
                                  }) as string
                                }
                                onChange={this.handleChangemoreInfoLink}
                                placeholder={'https://...'}
                                value={this.state.moreInfoLink}
                              />
                              <div>
                                <Button
                                  type="button"
                                  color={'black-outline'}
                                  onClick={this.handleSaveMoreInfoLink}
                                  loading={this.state.savingDescription}
                                >
                                  {
                                    i18n.t('confirm', {
                                      ns: 'taskManager',
                                    }) as string
                                  }
                                </Button>
                              </div>
                            </div>
                          </Collapsible>

                          <Collapsible
                            header={
                              <div>
                                <span>
                                  {
                                    i18n.t('moreInfoLink', {
                                      ns: 'modals',
                                    }) as string
                                  }
                                </span>
                              </div>
                            }
                          >
                            <div className="flex flex-col gap-3">
                              <Input
                                id="moreInfoLink"
                                type="text"
                                label={
                                  i18n.t('moreInfoLink', {
                                    ns: 'modals',
                                  }) as string
                                }
                                onChange={this.handleChangemoreInfoLink}
                                placeholder={'https://...'}
                                value={this.state.moreInfoLink}
                              />
                              <div>
                                <Button
                                  type="button"
                                  color={'black-outline'}
                                  onClick={this.handleSaveMoreInfoLink}
                                  loading={this.state.savingMoreInfoLink}
                                >
                                  {
                                    i18n.t('confirm', {
                                      ns: 'taskManager',
                                    }) as string
                                  }
                                </Button>
                              </div>
                            </div>
                          </Collapsible>
                        </>
                      )}
                    </div>
                  )}
                </InfoContainerWrapper>
                <SuperContainer className="col s12 m9">
                  {this.getContent(openItem)}
                </SuperContainer>
              </>
            )}
          </ModalBody>
        </DocumentModalContainer>
      </>
    );
  }
}
const mapStateToProps: MapStateToProps<IStateToProps, IProps, RootState> = (
  state,
  props
) => {
  let tags = state.providers?.tags?.[props.openItem.item.data.providerId]?.data;

  if (tags === undefined) {
    tags = {};
  }
  const thisUser = state.thisUser;

  return { ...props, tags, thisUser };
};

export default connect(mapStateToProps)(DocumentViewModal as any);
